var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"stripe":"","header-cell-style":{
      'text-align': 'center',
      'font-size': '14px',
      color: '#333333',
    },"cell-style":{ 'text-align': 'center', color: '#666666' }}},[_c('el-table-column',{attrs:{"prop":"type","label":"榜单名称"}}),_c('el-table-column',{attrs:{"prop":"ranking","label":"排名"}}),_c('el-table-column',{attrs:{"prop":"year","label":"数据更新年份"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }